<template>
    <FilterBase :title="title">
        <InputRangeTwoKnobbedWithInputs
            v-model="model"
            :min="bounds.min"
            :max="bounds.max"
            :step="step"
            :value-formatter="valueFormatter"
            :debounce="500"
        />
    </FilterBase>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { Bounds } from 'wucdbm-exponential-slider'

import type { GemsApi_RangeInput } from '@/graphql/api'

import FilterBase from '@/components/ui/filter/filters/layout/FilterBase.vue'
import type {
    InputRangeModel,
    InputRangeTwoKnobbedValueFormatter,
} from '@/components/ui/inputs/range/input-range-two-knobbed-props.ts'
import InputRangeTwoKnobbedWithInputs from '@/components/ui/inputs/range/InputRangeTwoKnobbedWithInputs.vue'

interface Props {
    modelValue: GemsApi_RangeInput | null | undefined
    bounds: Bounds
    step?: number
    title?: string
    valueFormatter?: InputRangeTwoKnobbedValueFormatter
}

const props = withDefaults(defineProps<Props>(), {
    modelValue: null,
    step: 1,
    valueFormatter: undefined,
    title: undefined,
})

const emit = defineEmits<{
    'update:modelValue': [input: GemsApi_RangeInput]
}>()

const model = computed({
    get: (): InputRangeModel => [props.modelValue?.min, props.modelValue?.max],
    set: (v: InputRangeModel) => {
        emit('update:modelValue', {
            min: v[0],
            max: v[1],
        })
    },
})
</script>
